import React from 'react';
import Helmet from 'react-helmet';
import { siteTitle } from '../../../data/SiteConfig';
import './Resource.css';
import Sidebar from '../../common/components/Sidebar/Sidebar';
import Header from '../../common/components/Header/Header';
function Resource() {
  return (
    <React.Fragment>
      <Helmet title={`Resource | ${siteTitle}`} />
      <div className="bg-grey-950 relative h-full overflow-hidden font-roboto text-sm font-normal m-0 p-0">
        <div className=" min-h-screen flex pt-17 md:pt-0 ">
          <Sidebar />
          <div className="widhtMd max-screen flex-1  w-full ">
            <Header />
            <div className="w-full md:w-8/12 flex-row px-4">
              <div className="w-full font-roboto text-2xl text-black-400 p-4 font-bold">
                Learning Center
              </div>
              <div className="w-full font-roboto text-xl text-green-600 pt-4 pl-4  font-semibold">
                Add Lead
              </div>
              <div className="w-full flex relative m-auto p-4">
                <iframe
                  id="ytplayer"
                  type="text/html"
                  width="100%"
                  height="405"
                  src="https://www.youtube.com/embed/u-T4kaeIBEc"
                  frameborder="0"
                  allowfullscreen
                ></iframe>
              </div>
              <div className="w-full font-roboto text-xl text-green-600 pt-4 pl-4  font-semibold">
                Add KYC details
              </div>
              <div className="w-full flex relative m-auto p-4">
                <iframe
                  id="ytplayer"
                  type="text/html"
                  width="100%"
                  height="405"
                  src="https://www.youtube.com/embed/GMzEI-80uvo"
                  frameborder="0"
                  allowfullscreen
                ></iframe>
              </div>
              <div className="w-full font-roboto text-xl text-green-600 pt-4 pl-4  font-semibold">
                Add Income details
              </div>
              <div className="w-full flex relative m-auto p-4">
                <iframe
                  id="ytplayer"
                  type="text/html"
                  width="100%"
                  height="405"
                  src="https://www.youtube.com/embed/ZUBW73SknLo"
                  frameborder="0"
                  allowfullscreen
                ></iframe>
              </div>
              <div className="w-full font-roboto text-xl text-green-600 pt-4 pl-4  font-semibold">
                Add property details
              </div>
              <div className="w-full flex relative m-auto p-4">
                <iframe
                  id="ytplayer"
                  type="text/html"
                  width="100%"
                  height="405"
                  src="https://www.youtube.com/embed/NLJObctJ_Dc"
                  frameborder="0"
                  allowfullscreen
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}
export default Resource;
